import * as index from '@syncfusion/ej2-dropdowns';
index.MultiSelect.Inject( index.CheckBoxSelection);
index.ListBox.Inject( index.CheckBoxSelection);
export * from '@syncfusion/ej2-dropdowns';
